export default {
  sports: {},
  categories: {},
  tournaments: {},
  bets: {},
  matches: [],
  activeSport: {},
  activeTournament: {},
  activeCategory: {},
  activeMatch: null,
  activeOutrightsSport: {},
  betslip: {
    bets: [],
    stake: 1,
    stakeChanged: false,
    type: 1,
    showBetslip: false,
    systems: [],
    possibleWinnings: {
      max: 0,
      bonus: 0,
      bonusPercent: 0,
    },
    moneyDenominations: [3, 10, 50, 100],
  },
  checkedTicket: {},
  oddType: 1,
  offerLoaded: false,
  notifications: [],
  balance: 0,
  device: {},
  cpvUuid: {},
  company: {},
  env: 'production',
  clientServiceTimeout: 10000,
  serverServiceTimeout: 30000,
  clientIntervalID: null,
  serverTimeoutID: null,
  modalState: false,
  ticketUpdateStatusValues: ['PAYEDOUT', 'CLOSED'],
  translations: {},
  userType: '',
  workingTimeBlocker: '',
  resetTrigger: false,
  alternativeStake: null,
};
